/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CreateAllocatedAmountBodySourceType =
  (typeof CreateAllocatedAmountBodySourceType)[keyof typeof CreateAllocatedAmountBodySourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAllocatedAmountBodySourceType = {
  available_amount: "available_amount",
  movable_asset: "movable_asset",
  immovable_asset: "immovable_asset",
  financial_asset: "financial_asset",
  pension_saving: "pension_saving",
} as const;
